import React from "react";
import { FiArrowRight, FiFileText } from "react-icons/fi";
import profileImg from "../assets/profile.jpg";

export default function Home() {
  return (
    <section id="home" className="home">
      <div className="container">
        <div className="hero">
          <div className="hero-text">
            <div className="hello">
              <span className="hello-badge">Available for Roles & Projects</span>
            </div>
            <h1 className="hero-title">Ayelgum Handson</h1>
            <h2 className="hero-role">
              Software Developer & IT Systems Engineer
            </h2>
            <p className="hero-tagline">
              Engineering resilient, full-stack digital solutions and architecting the secure, high-availability IT infrastructure that powers enterprise operations.
            </p>

            <div className="hero-actions">
              <a href="#contact" className="btn btn-primary">
                <span>Let's Connect</span>
                <FiArrowRight />
              </a>
              <a href="/AYELGUM_HANDSON_CV.pdf" className="btn btn-outline" download="Ayelgum_Handson_CV.pdf">
                <FiFileText />
                <span>View CV</span>
              </a>
            </div>
          </div>

          <div className="hero-visual">
            <div className="avatar-wrapper">
              <img
                src={profileImg}
                alt="Ayelgum Handson"
                className="hero-img"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  const svg = `<?xml version='1.0' encoding='UTF-8'?>\n<svg xmlns='http://www.w3.org/2000/svg' width='170' height='170'>\n  <rect width='100%' height='100%' rx='85' fill='#0f3b36'/>\n  <text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-family='Inter, Arial, sans-serif' font-size='52' font-weight='bold' fill='#bdeae3'>AH</text>\n</svg>`;
                  e.currentTarget.src =
                    "data:image/svg+xml;utf8," + encodeURIComponent(svg);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
